import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/sector",
    name: "Sector",
    component: () =>
      import(/* webpackChunkName: "sector" */ "../views/select/Sector.vue")
  },
  {
    path: "/sector/sport",
    name: "Sport",
    component: () =>
      import(/* webpackChunkName: "sport" */ "../views/achieve/Sport.vue")
  },
  {
    path: "/sport-mvb",
    name: "sportMvb",
    component: () =>
      import(/* webpackChunkName: "sportMvb" */ "../views/result/SportMvb.vue")
  },
  {
    path: "/sector/po-vo",
    name: "PoVo",
    component: () =>
      import(/* webpackChunkName: "povo" */ "../views/achieve/PoVo.vue")
  },
  {
    path: "/sector/po-vo/eigen-school",
    name: "PoVoOwnSchool",
    component: () =>
      import(
        /* webpackChunkName: "povoownschool" */ "../views/select/PoVoOwnSchool.vue"
      )
  },
  {
    path: "/sector/po-vo/eigen-school/accreditatie",
    name: "PoVoAccreditation",
    component: () =>
      import(
        /* webpackChunkName: "povoaccreditation" */ "../views/select/PoVoAccreditation.vue"
      )
  },
  {
    path: "/sector/ho",
    name: "Ho",
    component: () =>
      import(/* webpackChunkName: "ho" */ "../views/achieve/Ho.vue")
  },
  {
    path: "/sector/ho/eche",
    name: "HoEche",
    component: () =>
      import(/* webpackChunkName: "hoeche" */ "../views/select/HoEche.vue")
  },
  {
    path: "/sector/ho/eche/binnen-europa",
    name: "HoInEurope",
    component: () =>
      import(
        /* webpackChunkName: "hoineurope" */ "../views/select/HoInEurope.vue"
      )
  },
  {
    path: "/sector/ho/eche/hoger-onderwijsinstelling",
    name: "HohigherEducationInstitution",
    component: () =>
      import(
        /* webpackChunkName: "hohighereducationinstitution" */ "../views/select/HohigherEducationInstitution.vue"
      )
  },
  {
    path: "/sector/mbo",
    name: "Mbo",
    component: () =>
      import(/* webpackChunkName: "mbo" */ "../views/achieve/Mbo.vue")
  },
  {
    path: "/sector/mbo/accreditatie",
    name: "MboAccreditation",
    component: () =>
      import(
        /* webpackChunkName: "mboaccreditation" */ "../views/select/MboAccreditation.vue"
      )
  },
  {
    path: "/sector/ve",
    name: "Ve",
    component: () =>
      import(/* webpackChunkName: "ve" */ "../views/achieve/Ve.vue")
  },
  {
    path: "/sector/ve/accreditatie",
    name: "VeAccreditation",
    component: () =>
      import(
        /* webpackChunkName: "veaccreditation" */ "../views/select/VeAccreditation.vue"
      )
  },
  {
    path: "/sector/jeugd",
    name: "Youth",
    component: () =>
      import(/* webpackChunkName: "youth" */ "../views/achieve/Youth.vue")
  },
  {
    path: "/sector/jeugd/ondernemen",
    name: "YouthUndertake",
    component: () =>
      import(
        /* webpackChunkName: "youthundertake" */ "../views/select/YouthUndertake.vue"
      )
  },
  {
    path: "/sector/jeugd/ondernemen/waar",
    name: "YouthWhere",
    component: () =>
      import(
        /* webpackChunkName: "youthwhere" */ "../views/select/YouthWhere.vue"
      )
  },
  {
    path: "/sector/jeugd/ondernemen/waar-jongeren",
    name: "YouthWhereYouth",
    component: () =>
      import(
        /* webpackChunkName: "youthwhereyouth" */ "../views/select/YouthWhereYouth.vue"
      )
  },
  {
    path: "/sector/jeugd/ondernemen/leeftijd",
    name: "YouthAge",
    component: () =>
      import(/* webpackChunkName: "youthage" */ "../views/select/YouthAge.vue")
  },
  {
    path: "/sector/jeugd/organisatie",
    name: "YouthOrganization",
    component: () =>
      import(
        /* webpackChunkName: "youthorganization" */ "../views/select/YouthOrganization.vue"
      )
  },
  {
    path: "/sector/jeugd/organisatie/ontwikkeling-jongeren",
    name: "YouthYouthDevelopment",
    component: () =>
      import(
        /* webpackChunkName: "youthyouthdevelopment" */ "../views/select/YouthYouthDevelopment.vue"
      )
  },
  {
    path: "/sector/jeugd/organisatie/ontwikkeling-organisatie",
    name: "YouthOrganizationDevelopment",
    component: () =>
      import(
        /* webpackChunkName: "youthorganizationdevelopment" */ "../views/select/YouthOrganizationDevelopment.vue"
      )
  },
  {
    path:
      "/sector/jeugd/organisatie/ontwikkeling-organisatie/ervaringen-uitwisselen",
    name: "YouthExchangeExperiences",
    component: () =>
      import(
        /* webpackChunkName: "youthexchangeexperiences" */ "../views/select/YouthExchangeExperiences.vue"
      )
  },
  {
    path: "/ka210-sch",
    name: "Ka210Sch",
    component: () =>
      import(/* webpackChunkName: "ka210sch" */ "../views/result/Ka210Sch.vue")
  },
  {
    path: "/ka220-sch",
    name: "Ka220Sch",
    component: () =>
      import(/* webpackChunkName: "ka220sch" */ "../views/result/Ka220Sch.vue")
  },
  {
    path: "/ka120-ps",
    name: "Ka120PS",
    component: () =>
      import(
        /* webpackChunkName: "ka120ps" */ "../views/result/Ka120PS.vue"
      )
  },
  {
    path: "/ka120-lsv",
    name: "Ka120LSV",
    component: () =>
      import(
        /* webpackChunkName: "ka120lsv" */ "../views/result/Ka120LSV.vue"
      )
  },
  {
    path: "/ka120-lsa",
    name: "Ka120LSA",
    component: () =>
      import(
        /* webpackChunkName: "ka120lsa" */ "../views/result/Ka120LSA.vue"
      )
  },
  {
    path: "/ka122-sch",
    name: "Ka122Sch",
    component: () =>
      import(/* webpackChunkName: "ka122sch" */ "../views/result/Ka122Sch.vue")
  },
  {
    path: "/ka120-sch",
    name: "Ka120Sch",
    component: () =>
      import(/* webpackChunkName: "ka120sch" */ "../views/result/Ka120Sch.vue")
  },
  {
    path: "/ka121-sch",
    name: "Ka121Sch",
    component: () =>
      import(/* webpackChunkName: "ka121sch" */ "../views/result/Ka121Sch.vue")
  },
  {
    path: "/ka220-hed",
    name: "Ka220Hed",
    component: () =>
      import(/* webpackChunkName: "ka220hed" */ "../views/result/Ka220Hed.vue")
  },
  {
    path: "/ka131-hed",
    name: "Ka131Hed",
    component: () =>
      import(/* webpackChunkName: "ka131hed" */ "../views/result/Ka131Hed.vue")
  },
  {
    path: "/ka171-hed",
    name: "Ka171Hed",
    component: () =>
      import(/* webpackChunkName: "ka171hed" */ "../views/result/Ka171Hed.vue")
  },
  {
    path: "/eche-aanvragen",
    name: "RequestEche",
    component: () =>
      import(
        /* webpackChunkName: "requesteche" */ "../views/result/RequestEche.vue"
      )
  },
  {
    path: "/aanmerking",
    name: "NotEligible",
    component: () =>
      import(
        /* webpackChunkName: "noteligible" */ "../views/result/NotEligible.vue"
      )
  },
  {
    path: "/ka210-vet-vocational",
    name: "Ka210VetVocational",
    component: () =>
      import(/* webpackChunkName: "ka210vetvocational" */ "../views/result/Ka210VetVocational.vue")
  },
  {
    path: "/ka210-adu",
    name: "Ka210adu",
    component: () =>
      import(/* webpackChunkName: "Ka210adu" */ "../views/result/Ka210adu.vue")
  },
  {
    path: "/ka220-vet",
    name: "Ka220Vet",
    component: () =>
      import(/* webpackChunkName: "ka220vet" */ "../views/result/Ka220Vet.vue")
  },
  {
    path: "/ka121-vet",
    name: "Ka121Vet",
    component: () =>
      import(/* webpackChunkName: "ka121vet" */ "../views/result/Ka121Vet.vue")
  },
  {
    path: "/ka122-vet",
    name: "Ka122Vet",
    component: () =>
      import(/* webpackChunkName: "ka122vet" */ "../views/result/Ka122Vet.vue")
  },
  {
    path: "/ka120-vet",
    name: "Ka120Vet",
    component: () =>
      import(/* webpackChunkName: "ka120vet" */ "../views/result/Ka120Vet.vue")
  },
  {
    path: "/ka220-adu",
    name: "Ka220Adu",
    component: () =>
      import(/* webpackChunkName: "ka220adu" */ "../views/result/Ka220Adu.vue")
  },
  {
    path: "/ka121-adu",
    name: "Ka121Adu",
    component: () =>
      import(/* webpackChunkName: "ka121adu" */ "../views/result/Ka121Adu.vue")
  },
  {
    path: "/ka122-adu",
    name: "Ka122Adu",
    component: () =>
      import(/* webpackChunkName: "ka122adu" */ "../views/result/Ka122Adu.vue")
  },
  {
    path: "/ka120-adu",
    name: "Ka120Adu",
    component: () =>
      import(/* webpackChunkName: "ka120adu" */ "../views/result/Ka120Adu.vue")
  },
  {
    path: "/jongerenparticipatie",
    name: "YouthParticipation",
    component: () =>
      import(
        /* webpackChunkName: "youthparticipation" */ "../views/result/YouthParticipation.vue"
      )
  },
  {
    path: "/solidariteitsprojecten",
    name: "SolidarityProjects",
    component: () =>
      import(
        /* webpackChunkName: "solidarityprojects" */ "../views/result/SolidarityProjects.vue"
      )
  },
  {
    path: "/solidariteitsprojecten-jongeren",
    name: "SolidarityProjectsYouth",
    component: () =>
      import(
        /* webpackChunkName: "solidarityprojects" */ "../views/result/SolidarityProjectsYouth.vue"
      )
  },
  {
    path: "/europees-vrijwilligerswerk",
    name: "EuropeanVolunteering",
    component: () =>
      import(
        /* webpackChunkName: "europeanvolunteering" */ "../views/result/EuropeanVolunteering.vue"
      )
  },
  {
    path: "/europees-vrijwilligerswerk-jongeren",
    name: "EuropeanVolunteeringYouth",
    component: () =>
      import(
        /* webpackChunkName: "europeanvolunteering" */ "../views/result/EuropeanVolunteeringYouth.vue"
      )
  },
  {
    path: "/discovereu",
    name: "DiscoverEU",
    component: () =>
      import(
        /* webpackChunkName: "discovereu" */ "../views/result/DiscoverEu.vue"
      )
  },
  {
    path: "/jongerenuitwisselingen",
    name: "YouthExchanges",
    component: () =>
      import(
        /* webpackChunkName: "youthexchanges" */ "../views/result/YouthExchanges.vue"
      )
  },
  {
    path: "/discovereu-europees-vrijwilligerswerk",
    name: "DiscoverEuVolunteering",
    component: () =>
      import(
        /* webpackChunkName: "discovereuvolunteering" */ "../views/result/DiscoverEuVolunteering.vue"
      )
  },
  {
    path: "/mobiliteitsprojecten-voor-jongerenwerkers",
    name: "MobProYouthWorkers",
    component: () =>
      import(
        /* webpackChunkName: "mobproyouthworkers" */ "../views/result/MobProYouthWorkers.vue"
      )
  },
  {
    path: "/kleinschalige-partnerschappen",
    name: "SmallScalePartnerships",
    component: () =>
      import(
        /* webpackChunkName: "smallscalepartnerships" */ "../views/result/SmallScalePartnerships.vue"
      )
  },
  {
    path: "/samenwerkingspartnerschappen",
    name: "CollaborativePartnerships",
    component: () =>
      import(
        /* webpackChunkName: "collaborativepartnerships" */ "../views/result/CollaborativePartnerships.vue"
      )
  },
  {
    path: "/erasmus-accreditatie",
    name: "AccreditatieResult",
    component: () =>
      import(
        /* webpackChunkName: "accreditatieresult" */ "../views/result/AccreditatieResult.vue"
      )
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  // Reset focus (tabindex) when navigating.
  document.body.setAttribute("tabindex", "-1");
  document.body.focus();
  document.body.removeAttribute("tabindex");
  next();
});

export default router;
